var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginStatus === 1 && !_vm.IsPC)?_c('LoginAll'):(_vm.loginStatus === 2 && !_vm.IsPC)?_c('LoginSimplified'):_c('LoginPC')}
var staticRenderFns = []

export { render, staticRenderFns }